import { useEffect, useState } from 'react';
import { useFetcher, useNavigate } from 'react-router-dom';

const Login = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loginType, setLoginType] = useState(null);
    const fetcher = useFetcher();
    const navigate = useNavigate();

    useEffect(() => {
        if (fetcher.state === 'idle' && fetcher.data) {
            setIsSubmitting(false);

            if(fetcher.data.errors)
                return;

            if(!fetcher.data.token || !fetcher.data.refresh) {
                console.error('Login failed: No token or refresh token received');
                return;
            }

            // Store tokens in session and local storage
            sessionStorage.setItem('accessToken', fetcher.data.token);
            localStorage.setItem('refreshToken', fetcher.data.refresh);

            // save login type in local storage
            localStorage.setItem('userType', loginType);

            if(loginType === 'publisher')
                navigate('/publisher', { replace: true });
            else
                navigate('/client', { replace: true });
        }
    }, [fetcher.state, fetcher.data, navigate, loginType]);

    return (
        <div className='flex flex-col justify-center items-center h-screen w-screen'>
            <fetcher.Form method='POST' action='/user/login' onSubmit={() => setIsSubmitting(true)}>
                <div className='flex flex-col items-center p-4 rounded-md mb-4 shadow-lg border border-gray-200'>
                    <h1 className='text-3xl font-bold text-primary'>התחברות</h1>
                    <p className='mb-3'>שמחים לראותך שוב</p>

                    <div className="flex items-center border-2 py-2 px-3 rounded-md mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className='h-5 w-5 text-gray-400' viewBox="0 0 16 16" fill="currentColor" >
                            <path d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z" />
                            <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" />
                        </svg>
                        <input className="pr-2 outline-none border-none w-full" type="username" name="username" placeholder="שם משתמש" required/>
                    </div>

                    <div className="flex items-center border-2 py-2 px-3 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                        <input className="pr-2 outline-none border-none w-full" type="password" name="password" placeholder="סיסמה" required/>
                    </div>

                    <div className='flex items-center py-2 gap-4'>
                        <div>
                            <input type="radio" name="type" value="publisher" className='ml-2' onChange={() => setLoginType('publisher')} required />פאבלישר
                        </div>
                        <div>
                            <input type="radio" name="type" value="client" className='ml-2' onChange={() => setLoginType('client')} required />מפרסם
                        </div>
                    </div>

                    {fetcher.data && fetcher.data.errors ? (
                    <div className='text-red-500 text-sm'>
                        {fetcher.data.errors.map((error, index) => (
                        <p key={index}>{error}</p>
                        ))}
                    </div>
                    ) : null}

                    <div className='mt-4 flex w-full'>
                        <button name="submit" type="submit" className="bg-primary text-white border border-primary py-2 transition delay-100 grow rounded-lg text-center text-sm font-semibold hover:bg-blue-500 hover:text-white hover:border-blue-500 disabled:opacity-75 disabled:cursor-not-allowed" disabled={isSubmitting}>
                        {isSubmitting ? (
                            <div className="flex items-center justify-center">
                            <div className="h-4 w-4 ml-2 rounded-full animate-spin border-2 border-t-white border-gray-400 shadow-md"></div>
                            <span>מתחבר...</span>
                            </div>
                        ) : (
                            'התחברות'
                        )}
                        </button>
                    </div>
                </div>
            </fetcher.Form>
        </div>
    );
}

export default Login;